<template>
    <div>
      <el-dialog v-model="drawer" width="740px" style="min-height: 465px; padding: 0; border-radius: 8px;" :close-on-click-modal="false" :show-close="false">
        <template #header="{ close }">
          <div class="my-header">
            <div style="flex: 1;"></div>
            <el-icon color="#9EA0A5" @click="close" style="cursor: pointer; padding: 5px;"><Close /></el-icon>
          </div>
        </template>
        <div class="custom-dialog-box">
            <div class="edit-success-title">
                <img src="@/assets/img/common/icon-success-green.png"/>
                <span>申请主体保存成功！</span>
            </div>
            <span class="edit-success-tip">系统监测到以下 <span class="orange">未完成</span> 订单均使用<span class="bold">【{{ applicantName }}】</span>申请主体</span>
            <span class="edit-success-tip">是否同步更新订单信息并提交审核？</span>
            <el-table ref="table" :data="orderList" striped tooltip-effect="dark" :max-height="370" style="width: 690px; min-height: 200px; margin-left: 25px; margin-top: 14px;" :header-cell-style="{background: '#F7F7F8', color: '#222222', fontWeight: 'bold'}"
                      @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40px"></el-table-column>
                <el-table-column prop="orderIde" label="商标图样" width="80px">
                    <template #default="scope">
                        <el-image style="width: 40px; height: 40px;" :src="scope.row.brandLogo" :preview-src-list="[scope.row.brandLogo]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="bizName" label="商标名称" width="120px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="brandCgNos" label="注册类别" width="90px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="applicantName" label="申请人名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="diplomatNo" label="订单编号" width="120px"></el-table-column>
                <el-table-column prop="flow2StateName" label="订单状态" width="100px">
                  <template #default="scope">
                        <span style="color: #FF6655">{{ scope.row.flow2StateName }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="custom-dialog-footer" style="margin-top: 10px;">
                <div @click="drawer = false">取消</div>
                <div @click="submitOrders">确定提交已勾选订单</div>
            </div>
        </div>
      </el-dialog>
    </div>
  </template>
  <script>
  import { syncNotPassOrderApplicantInfo } from "@/server/applicant";
  export default {
    props: ['applicantId', 'orderList', 'applicantName'],
    data() {
      return {
        drawer: false,
        multipleSelection: [],
      };
    },
  
    mounted() { },
  
    methods: {
      // 初始化数据
      init() {
        let self = this;
        this.drawer = true;
        setTimeout(() => {
          this.$refs.table.toggleAllSelection()
        }, 500)
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 关闭弹窗
      handleClose() {
        this.drawer = false;
      },
      // 保存后续更新操作
      async submitOrders() {
        let self = this;
        if (self.multipleSelection.length > 0) {
          let params = {
            applicantId: self.applicantId,
            diplomatNos: self.multipleSelection.map(item => item.diplomatNo).join(",")
          }
          let res = await syncNotPassOrderApplicantInfo(params);
          self.$message.success("操作成功！");
          this.drawer = false
        } else {
          self.$message.error("请选择订单！");
        }
      },
    },
  };
  </script>
  <style lang="less" scoped>
  .my-header {
    display: flex;
    width: 100%;
    height: 50px;
    align-items: center;
    padding: 14px 15px 14px 20px;
  }
  .custom-dialog-box {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .edit-success-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 10px;
        margin-bottom: 40px;

        img {
            width: 48px;
            height: 48px;
            margin-left: 50px;
            margin-right: 14px;
        }

        span {
            font-size: 18px;
            font-weight: bold;
            color: #111111;
            line-height: 20px;
        }
    }

    .edit-success-tip {
        font-size: 14px;
        color: #111111;
        line-height: 19px;
        margin-bottom: 14px;
        margin-left: 50px;
        margin-right: 50px;

        .orange {
            color: #FF6655;
        }

        .bold {
            font-weight: bold;
        }
    }

    .custom-dialog-footer {
        width: 100%;
        height: 52px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        border-top: 1px solid #EEEEEE;
        box-sizing: border-box;

        div {
        height: 32px;
        border-radius: 2px;
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
        }

        div:nth-child(1) {
        width: 80px;
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        color: #666666;
        margin-right: 24px;
        }

        div:nth-child(2) {
        width: 170px;
        background: #FF7200;
        color: #FFFFFF;
        margin-right: 20px;
        }
    }

  }
  
  &:deep(.el-dialog__body) {
    padding: 0px !important;
    overflow: hidden;
  }
  </style>
  